import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

interface TrackingEvent {
  status: string;
  location: string;
  description: string;
  timestamp: string;
  source: string;
}

interface ShipmentTracking {
  awb: string;
  found: boolean;
  status?: string;
  origin?: string;
  destination?: string;
  events?: TrackingEvent[];
}

interface ShipmentState {
  tracking: ShipmentTracking | null;
  isLoading: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: ShipmentState = {
  tracking: null,
  isLoading: false,
  loading: false,
  error: null,
};

export const trackShipment = createAsyncThunk(
  'shipment/track',
  async (awb: string, { rejectWithValue }) => {
    try {
      const response = await fetch(`${import.meta.env.VITE_TRACKING_SERVICE_URL || 'http://localhost:3006'}/track/${awb}`);
      const data = await response.json();
      return data.data;
    } catch (error) {
      return rejectWithValue('Failed to fetch tracking data');
    }
  },
);

const shipmentSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    clearTracking(state) {
      state.tracking = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(trackShipment.pending, (state) => {
        state.isLoading = true;
        state.loading = true;
        state.error = null;
      })
      .addCase(trackShipment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.loading = false;
        state.tracking = action.payload;
      })
      .addCase(trackShipment.rejected, (state, action) => {
        state.isLoading = false;
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearTracking } = shipmentSlice.actions;
export default shipmentSlice.reducer;
